export default __webpack_public_path__ + "static/asia-ee812378b9989d125404c19f719ddbe8.svg";